import React, { Component } from "react";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import querystring from "querystring";
import * as R from "ramda";
import { Loader } from "cxa-components";
import LoginLayout from "./LoginLayout";
import { containerizeLoginCmp } from "./containerizeLoginCmp";
import { AUTH_TYPE_AUTHSERVER } from "actions/loginActions";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";
import { RouteMap } from "components/common/navigation/routeMap";

const MODE_DEFAULT_UI = "CxaApiServer";
const PROTOCOL_SAML = "SAML2";
const LOGIN_MAP_TO_DEFAULT_UI = [MODE_DEFAULT_UI, AUTH_TYPE_AUTHSERVER];
const EXTERNAL_REDIRECT = "ExternalRedirect";

class LoginSelector extends Component {
  constructor(props) {
    super(props);
    this.loginSelector = this.loginSelector.bind(this);
  }

  getQueryParams() {
    return querystring.parse(location.search.toLowerCase().substring(1));
  }

  getLoginModes() {
    const { loginConfig: { options } = {} } = this.props;
    const qry = this.getQueryParams();
    const defaultMode = [
      {
        authority: "CxaApiServer",
        protocol: "HTTP",
        description: "Employee User Login",
      },
    ];
    let supportedModes = options || defaultMode;

    if (qry.sp === "1" || !supportedModes.length) {
      supportedModes = defaultMode;
    }

    return supportedModes;
  }

  dispatchLoginMode(authority) {
    const { setLoginMode } = this.props;
    if (authority === AUTH_TYPE_AUTHSERVER) {
      // Need to store loginMode in localStorage otherwise state will be lost when redirect to ExternalLoginContainer
      localStorage.setItem("loginMode", "oauth");

      setLoginMode("oauth");
    } else {
      // Need to store loginMode in localStorage otherwise state will be lost when redirect to ExternalLoginContainer
      localStorage.setItem("loginMode", "default");

      setLoginMode("default");
    }
  }

  initLoginMode(authority) {
    const loginModes = this.getLoginModes();

    // init login mode
    if (loginModes.length) {
      const containOAuth = loginModes.filter(mode => mode.authority === AUTH_TYPE_AUTHSERVER);

      // contain oauth, set login mode to oauth
      if (containOAuth.length) {
        this.dispatchLoginMode(AUTH_TYPE_AUTHSERVER);
      } else {
        this.dispatchLoginMode(authority || "default");
      }
    }
  }

  loginSelector({ authority, protocol, externalRedirectUrl }) {
    const { history, clientName } = this.props;

    // init login mode
    this.initLoginMode(authority);

    if (protocol === PROTOCOL_SAML) {
      location.href = "/sso/sp/initiate-login?c=" + clientName;
    } else if (protocol === EXTERNAL_REDIRECT) {
      location.href = externalRedirectUrl;
    } else {
      history.push(`${RouteMap.Login}${location.search}`);
    }
  }

  componentDidMount() {
    const {
      query: { returnUrl = null } = {},
      loginConfig: { options: loginOptions = [] } = {},
    } = this.props;

    if (returnUrl) {
      // Store sso return url during login selection
      // Used by 3rd party app that integrate with this app
      sessionStorage.setItem("ssoReturnUrl", returnUrl);
    }

    // init login mode
    if (loginOptions.length) {
      this.initLoginMode();
    }
  }

  render() {
    const {
      redirectTo,
      isAuthenticated,
      settingsLoaded,
      settingsLoadingFailed,
      location,
      intl,
      clientName,
    } = this.props;

    const supportedModes = this.getLoginModes();
    const qry = this.getQueryParams();

    const canGotoLogin =
      settingsLoaded &&
      supportedModes.length === 1 &&
        R.contains(supportedModes[0].authority, LOGIN_MAP_TO_DEFAULT_UI);

    if (isAuthenticated) {
      if (qry.sp === "1") {
        location.href = "/sso/idp/login-assert";
      } else {
        // will redirect from '/' to '/dashboard' after login
        return <Redirect to={redirectTo} />;
      }
    } else if (canGotoLogin || settingsLoadingFailed) {
      return <Redirect to={`${RouteMap.Login}${location.search}`} />;
    }

    if (clientName && !settingsLoaded) {
      return <Loader />;
    }

    const actions = supportedModes.map(m => (
      <li key={m.authority}>
        <button
          className="button button--primary"
          onClick={() => this.loginSelector(m)}
          style={{ width: "100%" }}
        >
          {intl.formatMessage({
            id: m.description,
            defaultMessage: m.description,
          })}
        </button>
      </li>
    ));

    return (
      <LoginLayout {...this.props}>
        <div className="cxa-c-form">
          <legend>
            <h3>
              <span>{intl.formatMessage(messages.login.loginSelectionHeaderTitle)}</span>
            </h3>
          </legend>
          <ul className="apl-login__selector">{actions}</ul>
        </div>
      </LoginLayout>
    );
  }
}

LoginSelector.propTypes = {
  history: PropTypes.object,
  clientName: PropTypes.string,
  query: PropTypes.object,
  setLoginMode: PropTypes.func,
  loginConfig: PropTypes.object,
  intl: intlShape.isRequired,
  redirectTo: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  settingsLoaded: PropTypes.bool,
  settingsLoadingFailed: PropTypes.bool,
  location: PropTypes.any,
};

export default injectIntl(containerizeLoginCmp(LoginSelector));



// WEBPACK FOOTER //
// ./components/login/LoginSelector.jsx